import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm">实时同步最新发布的番号条目</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 bg-background-100 border-b border-background-200/60 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
            <div className="col-span-2">番号</div>
            <div className="col-span-5">标题</div>
            <div className="col-span-2">类型</div>
            <div className="col-span-2">发布日期</div>
            <div className="col-span-1"></div>
          </div>
          <div className="divide-y divide-background-100">
            {latestUpdates.map((item) => (
              <Link
                key={item.id}
                to={`/article/${item.id}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-5 py-3.5 hover:bg-background-100/60 transition-colors cursor-pointer"
              >
                <div className="md:col-span-2">
                  <span className="font-mono text-sm font-semibold text-primary-700">{item.code}</span>
                </div>
                <div className="md:col-span-5">
                  <span className="text-sm text-foreground-700 line-clamp-1">{item.title}</span>
                </div>
                <div className="md:col-span-2">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {item.genre}
                  </span>
                </div>
                <div className="md:col-span-2">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <div className="md:col-span-1 flex md:justify-end">
                  <i className="ri-arrow-right-s-line text-foreground-400 text-lg"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}